import React, { useEffect, useState } from 'react';
import { Table } from 'antd';

const FeatureLcienseTable = (props) => {
    const { pricingFeatureData, formData } = props;
    const  [dataSource ,setDataSource] = useState([])

    useEffect(()=>{
        setDataSource(pricingFeatureData)

    },[pricingFeatureData])

 

    // Helper to format currency
    const formatCurrency = (value) => {
        return value
            ? `$${Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            : '$0.00';
    };

    const formatPercentage= (value) => {
        return value
            ? `${Number(value * 100).toFixed(1)}%`
            : '0.00%';
    };

      const getTitle = (title) => {
            if (title == 'Lincoln Power Supply')
                return 'Lincoln PS'
            else if (title == 'Fronius Power Supply')
                return 'Fronius TPSi'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Zone to Zone Ramping')
                return 'Zone Ramping'
            else if (title == 'Touch ramp')
                return 'Touch'
            else
                return title
        }

    const columns = [
        {
            title: 'Welding System',
            dataIndex: 'Welding',
            key: 'Welding',
            align: 'left',
        },
        {
            title: 'License',
            dataIndex: 'License',
            key: 'License',
            align: 'left',
            render: (value) => getTitle(value),
        },
        {
            title: 'Quantity',
            dataIndex: 'Quantity',
            key: 'Quantity',
            align: 'center',
        },
        {
            title: 'License Duration',
            dataIndex: 'Duration',
            key: 'Duration',
            align: 'center',
        },
        {
            title: 'Duration Discount',
            dataIndex: 'Duration_discount',
            key: 'GrandTotal',
            align: 'center',
            render: (value) => formatPercentage(value),
        },
        {
            title: 'Tier Discount',
            dataIndex: 'Tier_discount',
            key: 'Tier_discount',
            align: 'center',
            render: (value) => formatPercentage(value),
        },
        {
            title: 'Unit Sale Price',
            dataIndex: 'Unit_Lic_price_tier_disc',
            key: 'Unit_Lic_price_tier_disc',
            align: 'right',
            render: (value) => formatCurrency(value),
        },
        {
            title: 'Total Sale Price',
            dataIndex: 'Total_lic_price',
            key: 'Total_lic_price',
            align: 'right',
            render: (value) => formatCurrency(value),
        },
    ];

    return (
        <div className="pricing-guidance-table-wrap">
            <Table
                style={{ width: '100%', margin: 0, padding: 0 }}
                className="feature-license-pricing-table pricing-guidance-table"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                size="middle"
                tableLayout="fixed"
                rowKey={(record, index) => `${record.Welding || 'row'}-${record.License || index}-${index}`}
            />
        </div>
    );
};

export default FeatureLcienseTable;
